var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useRef, forwardRef } from "react";
import { AccordionContext } from "./Accordion.context";
import { AccordionGroupContext } from "./AccordionGroup.context";
var AccordionTitle = forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.as, Component = _b === void 0 ? "h3" : _b, className = _a.className, style = _a.style, otherProps = __rest(_a, ["children", "as", "className", "style"]);
    var contextValue = useContext(AccordionContext);
    var accordionGroupContext = useContext(AccordionGroupContext);
    var buttonRef = useRef(null);
    if (!contextValue) {
        console.warn("AccordionContext provider is needed");
        return null;
    }
    var id = contextValue.id, expanded = contextValue.expanded, onToggle = contextValue.onToggle;
    var handleKeyDown = function (event) {
        if (!accordionGroupContext)
            return;
        switch (event.key) {
            case "Enter":
            case " ":
                event.preventDefault();
                if (onToggle) {
                    onToggle(id);
                }
                break;
            case "ArrowDown":
                event.preventDefault();
                if (accordionGroupContext) {
                    accordionGroupContext.moveFocusToNextAccordionHeader(id);
                }
                break;
            case "ArrowUp":
                event.preventDefault();
                if (accordionGroupContext) {
                    accordionGroupContext.moveFocusToPreviousAccordionHeader(id);
                }
                break;
            case "Home":
                event.preventDefault();
                if (accordionGroupContext) {
                    accordionGroupContext.moveFocusToFirstAccordionHeader();
                }
                break;
            case "End":
                event.preventDefault();
                if (accordionGroupContext) {
                    accordionGroupContext.moveFocusToLastAccordionHeader();
                }
                break;
            default:
                break;
        }
    };
    return (React.createElement(Component, __assign({}, otherProps, { className: "fr-accordion__title " + (className ? className : ""), style: style, ref: ref }),
        React.createElement("button", { ref: buttonRef, id: "".concat(id, "-header"), className: "fr-accordion__btn", "aria-expanded": expanded, "aria-controls": id, onClick: function () {
                if (onToggle) {
                    onToggle(id);
                }
            }, onKeyDown: handleKeyDown, type: "button" }, children)));
});
export default AccordionTitle;
